module.exports = __webpack_public_path__ + "img/logo-m60-white.50b9a06b.svg";